module.exports = __webpack_public_path__ + "static/media/icomoon.e8d38dfd.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fonts/icomoon.woff
 ** module id = 1257
 ** module chunks = 0
 **/